import { HttpClient } from "./serviceBase";

class GeoService {
    GetPrices = async (code) =>
        await HttpClient.Get(`/api/geo/currencyPrices/code/${code}`)
}

export default new GeoService();